<template>
  <div class="warrantyItems">
    <el-table
      ref="table"
      :data="rows"
      :highlight-current-row="false"
      border
      class="c-table-border"
      height="100%"
    >
      <!-- 数据为空时不显示"暂无数据" -->
      <template slot="empty">
        <div class="c-none"></div>
      </template>
      <el-table-column class-name="slash" width="300" fixed prop="test">
        <!-- 第一列 -->
        <!-- #header解决slot="header"视图不刷新问题 -->
        <template #header="">
          <div class="headerCell">
            <div class="headerCell-left">工序</div>
            <div class="headerCell-right">材料</div>
          </div>
          <!-- 左下角添加按钮 表格1条数据都没有时展示 -->
          <i
            v-if="rows.length == 0 && osg.has('WarrantyItems,operation')"
            @click="rowAdd"
            class="el-icon-circle-plus c_blue c_size_20 c_pointer row-add-empty"
          ></i>
        </template>
        <template slot-scope="scope">
          <!-- 工序单元格 -->
          <template v-if="currentRowIndex === scope.$index">
            <el-select
              v-model="rows[scope.$index][0]"
              multiple
              filterable
              placeholder="请选择工序"
              :disabled="currentRowIndex !== scope.$index"
            >
              <el-option
                v-for="item in options.procedures"
                :key="item._id"
                :label="item.content"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <p v-for="(value, valueIndex) in rows[scope.$index][0]" :key="valueIndex">
              {{
                osg.codelabel('procedures', value) == '未知'
                  ? value
                  : osg.codelabel('procedures', value)
              }}
            </p>
          </template>
          <!-- 左侧行号 -->
          <div class="no-left">{{ scope.$index + 1 }}</div>
          <!-- 左侧操作按钮 -->
          <div class="action-buttons-left" v-if="osg.has('WarrantyItems,operation')">
            <template v-if="currentRowIndex === scope.$index">
              <span @click="rowSave(scope.$index)" class="c_pointer c_green">
                <i class="el-icon-success"></i>
                保存
              </span>
              <span @click="rowCancel(scope.$index)" class="c_pointer c_blue">
                <i class="el-icon-refresh-left"></i>
                取消
              </span>
            </template>
            <template v-else-if="currentRowIndex === null">
              <span @click="rowEdit(scope.$index)" class="c_pointer c_blue">
                <i class="el-icon-edit"></i>
                编辑
              </span>
              <span @click="rowRemove(scope.$index)" class="c_pointer c_red">
                <i class="el-icon-delete"></i>
                删除
              </span>
            </template>
          </div>
          <!-- 左下角添加按钮 表格有数据时展示 -->
          <i
            v-if="
              scope.$index == rows.length - 1 &&
                currentRowIndex === null &&
                osg.has('WarrantyItems,operation')
            "
            @click="rowAdd"
            class="el-icon-circle-plus c_blue c_size_20 c_pointer row-add"
          ></i>
        </template>
      </el-table-column>
      <!-- 材料列 -->
      <el-table-column
        v-for="(column, columnIndex) in columns"
        :key="columnIndex"
        width="300"
        :data-index="columnIndex"
      >
        <template slot="header" slot-scope="header">
          <div class="no-top">{{ columnNumber[columnIndex] }}</div>
          <!-- 顶部删除整列按钮 -->
          <div class="action-buttons-top" v-if="osg.has('WarrantyItems,operation')">
            <template v-if="currentColumnIndex === columnIndex">
              <span class="c_pointer c_blue" @click="columnCancel(columnIndex)">
                <i class="el-icon-refresh-left"></i>
                取消
              </span>
              <span class="c_pointer c_green" @click="columnSave(columnIndex)">
                <i class="el-icon-success"></i>
                保存
              </span>
            </template>
            <template v-else-if="currentColumnIndex === null">
              <span class="c_pointer c_red" @click="columnRemove(columnIndex)">
                <i class="el-icon-delete"></i>
                删除
              </span>
              <span class="c_pointer c_blue" @click="columnEdit(columnIndex)">
                <i class="el-icon-edit"></i>
                编辑
              </span>
            </template>
          </div>
          <!-- 材料表头单元格 -->
          <template v-if="currentColumnIndex === columnIndex">
            <el-select
              v-model="columns[header.$index - 1]"
              multiple
              filterable
              placeholder="请选择材料"
              :disabled="currentColumnIndex !== columnIndex"
            >
              <el-option
                v-for="item in options.materials"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <p v-for="(value, valueIndex) of columns[header.$index - 1]" :key="valueIndex">
              {{
                osg.codelabel('materials', value) == '未知'
                  ? value
                  : osg.codelabel('materials', value)
              }}
            </p>
          </template>
        </template>
        <!-- 年限单元格 -->
        <template slot-scope="scope">
          <!-- 根据材料和工序完全匹配判断，是否已维护对应的质保年限 -->
          <div
            v-if="
              rows[scope.$index].find(
                currentCell =>
                  !Array.isArray(currentCell) &&
                  currentCell.materialIds
                    .slice()
                    .sort()
                    .toString() ==
                    columns[columnIndex]
                      .slice()
                      .sort()
                      .toString()
              )
            "
          >
            <div v-for="(cell, i) in rows[scope.$index]" :key="i">
              <!-- 仅展示当前材料和表头材料完全匹配的质保年限 -->
              <div
                v-if="
                  i != 0 &&
                    cell.materialIds
                      .slice()
                      .sort()
                      .toString() ==
                      columns[columnIndex]
                        .slice()
                        .sort()
                        .toString()
                "
                @click="cellShow(scope.$index, columnIndex)"
                class="c-center pointer"
              >
                <!-- 
                  输入框类型
                  <el-input
                  type="number"
                  v-model="cell.years"
                  :ref="'input-' + scope.$index + '-' + columnIndex"
                  @blur="cellBlur(cell, scope.$index, i)"
                ></el-input> -->
                <el-select
                  v-if="currentCellIndex == columnIndex && currentCellRowIndex == scope.$index"
                  v-model="cell.years"
                  :disabled="
                    !osg.has('WarrantyItems,operation') && !osg.has('WarrantyItems,selectable')
                  "
                  filterable
                  :ref="'input-' + scope.$index + '-' + columnIndex"
                  :clearable="osg.has('WarrantyItems,operation') ? true : false"
                  @change="cellChange(cell, scope.$index, i)"
                  @visible-change="visibleChange($event, cell, scope.$index, i)"
                  popper-class="years-option"
                >
                  <el-option
                    v-for="item in options.agelimit"
                    :key="item.value"
                    :label="item.label"
                    :value="Number(item.value)"
                  ></el-option>
                </el-select>
                <span v-else>{{ osg.codelabel('agelimit', cell.years) }}</span>
              </div>
            </div>
          </div>
          <!-- 当未维护对应质保时 点击单元格添加质保对象 -->
          <div
            v-else
            @click="cellClick(scope.$index, columnIndex)"
            style="min-height:32px"
            class="pointer"
          ></div>
        </template>
      </el-table-column>
      <!-- 右上角添加列按钮 添加材料；当前有在编辑的列时，不允许新增列； -->
      <!-- 待优化：控制添加列后尽量先维护当前列的至少1个质保年限，页面加载时列的顺序是按质保年限维护时间先后排序的；行也是这样的排序; -->
      <el-table-column
        width="40px"
        class-name="th-addcloumn"
        v-if="osg.has('WarrantyItems,operation')"
      >
        <template slot="header" v-if="currentColumnIndex === null">
          <i
            @click="columnAdd"
            class="el-icon-circle-plus c_blue c_size_20 c_pointer"
            style="vertical-align: middle;"
          ></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      name: 'WarrantyItems',
      type: '',
      tenantId: '',
      loginOrgId: '',
      columns: [],
      rows: [],
      options: {
        codecfg_agelimit: { codeId: 'agelimit' },
        materials: [],
        procedures: []
      },
      currentColumnIndex: null, //当前编辑列
      currentColumn: [], //当前编辑的材料
      currentRowIndex: null, //当前编辑行
      currentRow: [], //当前编辑的工序
      currentCellIndex: null, //当前点击单元格的列号
      currentCellRowIndex: null, //当前点击单元格的行号
      columnNumber: [] //列编号A-Z等
    };
  },
  mounted() {
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;
    this.newColumnNumber(100);
    this.getMaterials();
    this.getProcedures();
    this.osg.codeoption(() => {
      this.getData();
    });
  },
  methods: {
    getMaterials() {
      this.osg.ajax(
        'basic/material/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1',
          'is:approveState|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.materials = res.data;
          this.$forceUpdate();
        }
      );
    },
    getProcedures() {
      this.osg.ajax(
        'biz/procedure/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:approveState|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.content;
            item.value = item._id;
          });
          this.options.procedures = res.data;
        }
      );
    },
    getData() {
      this.osg.ajax(
        'basic/warrantyItem/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1',
          'exists:auditStatus|boolean#and': false,
          sortField: 'createTime',
          sortOrder: 'asc'
        },
        res => {
          console.log('返回时间', new Date());
          let columns = [];
          let rows = [];
          let data = res.data;
          for (let item of data) {
            // 整理不同的材料组合不同的列展示
            if (
              !columns.find(column => {
                return (
                  column
                    .slice()
                    .sort()
                    .toString() ==
                  item.materialIds
                    .slice()
                    .sort()
                    .toString()
                );
              })
            ) {
              columns.push(item.materialIds.slice());
            }
            // 按工序分组：相同工序的质保年限放到1行
            let num = 0;
            for (let i = 0; i < rows.length; i++) {
              if (
                item.procedureIds &&
                rows[i][0]
                  .slice()
                  .sort()
                  .toString() ==
                  item.procedureIds
                    .slice()
                    .sort()
                    .toString()
              ) {
                rows[i].push(item);
                ++num;
                break;
              }
            }
            // 判断是否已有此工序的行
            if (num == 0 && item.procedureIds) rows.push([item.procedureIds.slice(), item]);
          }
          this.columns = columns;
          this.rows = rows;
          console.log('处理完成时间', new Date());
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      );
    },
    columnAdd() {
      // 增加1列
      this.columns.push([]);
      // 将刚增加的列标记为当前修改的列
      this.currentColumnIndex = this.columns.length - 1;
      this.currentColumn = this.columns[this.columns.length - 1].slice();
      this.$forceUpdate();
    },
    columnEdit(columnIndex) {
      this.currentColumnIndex = columnIndex;
      this.currentColumn = this.columns[columnIndex].slice();
    },
    columnSave(columnIndex) {
      // 1.至少选择1个材料
      if (this.columns[columnIndex].length == 0) {
        this.osg.toast('请至少选择1个材料！');
        return;
      }
      // 2.判断当前选择材料组合是否已存在
      for (let i = 0; i < this.columns.length; i++) {
        if (
          i != columnIndex &&
          this.columns[i]
            .slice()
            .sort()
            .toString() ==
            this.columns[columnIndex]
              .slice()
              .sort()
              .toString()
        ) {
          let str = this.osg.codelabelForArray('materials', this.columns[i]);
          this.osg.confirm(
            `在表格第${i +
              2}列已存在相同的材料组合：“${str}”，点击确认按钮将为您恢复至修改前的材料！`,
            () => {
              // this.columns[columnIndex] = this.currentColumn.slice();
              this.$set(this.columns, columnIndex, this.currentColumn.slice());
              // 如果之前1条材料都没选择，继续保持编辑状态
              if (this.currentColumn.length > 0) {
                this.currentColumnIndex = null;
              }
              this.currentColumn = [];
            }
          );
          return;
        }
      }
      // 3.如果之前已经选择过材料，判断是否有之前的数据，需要同步修改
      if (this.currentColumn.length > 0) {
        let changeArray = [];
        for (let i = 0; i < this.rows.length; i++) {
          for (let j = 1; j < this.rows[i].length; j++) {
            if (
              this.rows[i][j].materialIds
                .slice()
                .sort()
                .toString() ==
              this.currentColumn
                .slice()
                .sort()
                .toString()
            ) {
              this.rows[i][j].materialIds = this.columns[columnIndex];
              changeArray.push(this.rows[i][j]);
            }
          }
        }
        if (changeArray.length > 0) {
          this.osg.ajax(
            '/basic/warrantyItem/batchUpsert.do',
            { data: JSON.stringify(changeArray) },
            () => {
              this.currentColumnIndex = null;
              this.currentColumn = [];
              this.osg.toast('修改成功');
              this.getData();
            }
          );
        } else {
          this.currentColumnIndex = null;
          this.currentColumn = [];
        }
      } else {
        this.currentColumnIndex = null;
        this.currentColumn = [];
      }
    },
    columnCancel(columnIndex) {
      if (this.currentColumn.length == 0) {
        // 之前未选择材料，则删除当前列
        this.columns.splice(columnIndex, 1);
      } else {
        // 之前已选择材料，则恢复之前选择的材料
        this.columns[columnIndex] = this.currentColumn.slice();
      }
      this.currentColumnIndex = null;
      this.currentColumn = [];
    },
    columnRemove(columnIndex) {
      this.osg.confirm('是否确认删除当前列？', () => {
        let materialIds = this.columns[columnIndex];
        if (materialIds.length == 0) {
          this.columns.splice(columnIndex, 1);
          this.osg.toast('删除成功');
          return;
        }

        let ids = [];
        // 查询当前列每行中对应单元格的id
        for (let i = 0; i < this.rows.length; i++) {
          for (let j = 1; j < this.rows[i].length; j++) {
            if (
              materialIds
                .slice()
                .sort()
                .toString() ==
              this.rows[i][j].materialIds
                .slice()
                .sort()
                .toString()
            ) {
              ids.push(this.rows[i][j]._id);
              continue;
            }
          }
        }
        if (ids.length > 0) {
          this.osg.ajax('/basic/warrantyItem/batchRemove.do', { ids: ids.join() }, () => {
            // 找出每行中对应的那1个单元格删除
            for (let i = 0; i < this.rows.length; i++) {
              for (let j = 1; j < this.rows[i]; j++) {
                if (ids.indexOf(this.rows[i][j]._id) != -1) {
                  this.rows[i].splice(j, 1);
                  continue;
                }
              }
            }
            this.columns.splice(columnIndex, 1);
            this.osg.toast('删除成功');
          });
        } else {
          this.columns.splice(columnIndex, 1);
          this.osg.toast('删除成功');
        }
      });
    },
    rowAdd() {
      this.rows.push([[]]);
      // 将刚增加的行标记为当前修改的列
      this.currentRowIndex = this.rows.length - 1;
      this.currentRow = this.rows[this.rows.length - 1][0].slice();
      this.$forceUpdate();
    },
    rowEdit(rowIndex) {
      this.currentRowIndex = rowIndex;
      this.currentRow = this.rows[rowIndex][0].slice();
      this.$forceUpdate();
    },
    rowSave(rowIndex) {
      // 1.至少选择1个工序
      if (this.rows[rowIndex][0].length == 0) {
        this.osg.toast('请至少选择1个工序！');
        return;
      }
      // 2.判断当前选择工序组合是否已存在
      for (let i = 0; i < this.rows.length; i++) {
        if (
          i != rowIndex &&
          this.rows[i][0]
            .slice()
            .sort()
            .toString() ==
            this.rows[rowIndex][0]
              .slice()
              .sort()
              .toString()
        ) {
          let str = this.osg.codelabelForArray('procedures', this.rows[i][0]);
          this.osg.confirm(
            `在表格第${i +
              2}行已存在相同的工序组合：“${str}”，点击确认按钮将为您恢复至修改前的工序！`,
            () => {
              this.$set(this.rows[rowIndex], 0, this.currentRow.slice());
              // 如果之前1条工序都没选择，继续保持编辑状态
              if (this.currentRow.length > 0) {
                this.currentRowIndex = null;
              }
              this.currentRow = [];
            }
          );
          return;
        }
      }
      // 3.如果之前已经选择过工序，判断是否有之前的数据，需要同步修改
      if (this.currentRow.length > 0) {
        let changeArray = [];
        for (let i = 1; i < this.rows[rowIndex].length; i++) {
          this.rows[rowIndex][i].procedureIds = this.rows[rowIndex][0];
          changeArray.push(this.rows[rowIndex][i]);
        }
        if (changeArray.length > 0) {
          this.osg.ajax(
            '/basic/warrantyItem/batchUpsert.do',
            { data: JSON.stringify(changeArray) },
            () => {
              this.currentRowIndex = null;
              this.currentRow = [];
              this.osg.toast('修改成功');
              this.getData();
            }
          );
        } else {
          this.currentRowIndex = null;
          this.currentRow = [];
        }
      } else {
        this.currentRowIndex = null;
        this.currentRow = [];
      }
    },
    rowCancel(rowIndex) {
      if (this.currentRow.length == 0) {
        // 之前未选择工序，则删除当前行
        this.rows.splice(rowIndex, 1);
      } else {
        // 之前已选择工序，则恢复之前选择的工序
        this.rows[rowIndex][0] = this.currentRow.slice();
      }
      this.currentRowIndex = null;
      this.currentRow = [];
    },
    rowRemove(rowIndex) {
      this.osg.confirm('是否确认删除当前行？', () => {
        let currentRow = this.rows[rowIndex];
        let ids = [];
        for (let i = 1; i < currentRow.length; i++) {
          ids.push(currentRow[i]._id);
        }
        if (ids.length > 0) {
          this.osg.ajax('/basic/warrantyItem/batchRemove.do', { ids: ids.join() }, () => {
            this.rows.splice(rowIndex, 1);
            this.osg.toast('删除成功');
          });
        } else {
          this.rows.splice(rowIndex, 1);
          this.osg.toast('删除成功');
        }
      });
    },
    cellShow(rowIndex, columnIndex) {
      this.currentCellRowIndex = rowIndex;
      this.currentCellIndex = columnIndex;
      this.$nextTick(() => {
        this.$forceUpdate();
        this.$refs['input-' + rowIndex + '-' + columnIndex] &&
          this.$refs['input-' + rowIndex + '-' + columnIndex][0] &&
          this.$refs['input-' + rowIndex + '-' + columnIndex][0].focus();
      });
    },
    cellClick(rowIndex, columnIndex) {
      // 判断是否已选择工序和材料
      let procedureIds = this.rows[rowIndex][0].slice();
      let materialIds = this.columns[columnIndex].slice();
      if (procedureIds.length == 0 && materialIds.length == 0) {
        this.osg.toast('请先选中工序和材料');
        return;
      } else if (procedureIds.length == 0) {
        this.osg.toast('请先选择本行左侧的工序');
        return;
      } else if (materialIds.length == 0) {
        this.osg.toast('请先选择本列顶部的材料');
        return;
      }
      // 添加质保对象
      this.rows[rowIndex].push({
        procedureIds,
        materialIds,
        years: null
      });
      this.cellShow(rowIndex, columnIndex);
    },
    // 质保年限新建、修改、清空时触发
    cellChange(cell, rowIndex, currentIndex) {
      // 删除:undefined null "" 等情况
      if (!cell.years && cell.years !== 0) {
        // change清空事件，肯定已经保存过质保年限 需要删除质保
        this.cellRemove(cell._id, rowIndex, currentIndex);
      } else {
        // 保存
        this.cellSave(cell, rowIndex, currentIndex);
      }
    },
    // 质保年限下拉框隐藏时，如果未选择质保年限 需要删除单元格，
    visibleChange(visible, cell, rowIndex, currentIndex) {
      if (visible) return;
      // 删除:undefined null "" 等情况
      if (!cell._id && !cell.years && cell.years !== 0) {
        // 有cell._id 则已保存过 需要删除质保 此场景会触发change事件 此处无需处理
        // 没有cell._id 则未保存过 需要直接删除（点击单元格新建但是没选择的场景，此场景不会触发change事件）
        this.rows[rowIndex].splice(currentIndex, 1);
      }
    },
    // 输入类型的质保年限
    // cellBlur(cell, rowIndex, currentIndex) {
    //   // 删除:undefined null "" 等情况
    //   if (!cell.years && cell.years !== 0) {
    //     if (cell._id) {
    //       // 删除质保
    //       this.cellRemove(cell._id, rowIndex, currentIndex);
    //     } else {
    //       // 未保存过 直接删除
    //       this.rows[rowIndex].splice(currentIndex, 1);
    //     }
    //   } else {
    //     // 保存
    //     this.cellSave(cell, rowIndex, currentIndex);
    //   }
    // },
    cellSave(cell, rowIndex, currentIndex) {
      this.osg.ajax(
        'basic/warrantyItem/upsert.do',
        { data: JSON.stringify(cell) },
        res => {
          this.$set(this.rows[rowIndex], currentIndex, res.data);
        },
        {
          noload: true
        }
      );
    },
    cellRemove(id, rowIndex, currentIndex) {
      this.osg.ajax(
        `basic/warrantyItem/remove/${id}.do`,
        null,
        () => {
          this.rows[rowIndex].splice(currentIndex, 1);
        },
        {
          noload: true
        }
      );
    },
    newColumnNumber(number) {
      let alphabet = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ];
      let columnNumber = [];
      for (let i = 1; i <= number; i++) {
        if (i <= 26) {
          columnNumber.push(alphabet[i - 1]);
        } else {
          columnNumber.push(
            alphabet[Math.floor((i - 1) / 26) - 1] + alphabet[i % 26 == 0 ? 25 : (i % 26) - 1]
          );
        }
      }
      this.columnNumber = columnNumber;
    }
  }
};
</script>
<style lang="scss">
.warrantyItems {
  padding: 10px !important;
  overflow: hidden;
  // 列顶部操作按钮
  .action-buttons-top {
    position: absolute;
    top: -25px;
    left: 0;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    > span {
      margin: 0 10px;
    }
  }
  // 顶部列号
  .no-top {
    position: absolute;
    top: -25px;
    left: 10px;
    z-index: 0;
    color: #999;
  }
  // 左侧行号
  .no-left {
    position: absolute;
    top: 1px;
    left: 3px;
    z-index: 0;
    color: #999;
  }
  // 行左侧操作按钮
  .action-buttons-left {
    position: absolute;
    top: 0;
    left: 20px;
    z-index: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  // 添加行按钮
  .row-add-empty {
    display: flex;
    margin-left: 130px;
    margin-bottom: -5px;
  }
  .row-add {
    position: absolute;
    bottom: -40px;
    left: calc(50% - 10px);
    z-index: 1;
    padding-bottom: 10px;
  }
  .el-table {
    .el-table__fixed-body-wrapper {
      z-index: 2;
    }

    // 预留顶部操作按钮的控件
    th {
      padding-top: 30px;
    }
    th:first-child {
      padding-top: 10px;
    }
    th:last-child {
      padding-top: 10px;
    }

    tr td:first-child {
      padding-left: 60px;
    }

    .cell {
      min-height: 23px;
    }
    .el-select {
      width: 100%;
    }
  }

  // 表格左上角第一个格 斜线
  th.slash:before {
    position: absolute;
    content: ' ';
    height: 100%;
    width: 100%;
    background: linear-gradient(to top right, white, white 49%, #ebeef5, white 51%, white);
    left: 0;
    top: 0;
  }
  .el-table__header-wrapper {
    // overflow-x: auto;
    // overflow-y: visible;
    th.slash {
      overflow: visible !important;
      .cell {
        overflow: visible;
      }
    }
  }

  // 表格左上角第一个格 文字
  .headerCell {
    height: 23px;
    position: relative;
    .headerCell-left {
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .headerCell-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  // 材料选择器顶部对齐
  .el-table__header th {
    vertical-align: top;
    // 展示顶部删除列按钮
    overflow: visible !important;
    .cell {
      overflow: visible;
    }
  }
  .el-table__header th:first-child {
    vertical-align: middle;
  }
  // 右上角添加列按钮右边框显示
  .el-table__header th:last-child {
    border-bottom: none !important;
    vertical-align: middle;
  }
  .el-table__header th.th-addcloumn {
    padding-top: 10px;
    vertical-align: middle;
  }
  .el-table__body tr td:last-child {
    border-bottom: none !important;
    border-right: none !important;
  }
  // 年份选择框内文本居中
  .pointer .el-input__inner {
    text-align: center;
  }
}
// 年份下拉选项文本居中
.years-option {
  .el-select-dropdown__item {
    text-align: center !important;
  }
}
</style>
